import React from "react";
import moment from "moment";
import { formatDuration } from "utils";
import { CommonProgressBar, CommonTooltip } from "shared";
import greenCheckedFilled from "assets/images/icons/green-check-filled.svg";

export const CourseGroupCard = ({
  element,
  onClick,
  isAssignment,
  isTheory,
  displayDuration,
}) => {
  const {
    name,
    hasPassed,
    isActive,
    startDate,
    endDate,
    totalDuration,
    numberOfCourses,
    taskProgressPercentage,
  } = element;
  const showDuration = isAssignment && displayDuration;
  const passed = hasPassed === false && isAssignment;

  const formattedDate = (date) => {
    return date ? moment(date)?.format("DD-MM-YYYY hh:mm A") : "--";
  };

  return (
    <div
      className={`grid-item mini-grid-item course-group-card ${
        isActive ? "" : "disabled"
      }`}
      onClick={onClick}
      aria-disabled={!isActive}
    >
      <div
        className={`grid-item-content ${isTheory ? "theory-course-group" : ""}`}
      >
        <CommonTooltip text={name} position="bottom">
          <h2 className="ellipsis-text overflow-hidden">{name}</h2>
        </CommonTooltip>
        {!isTheory && (
          <>
            <div className="grid-sub-text">{numberOfCourses} Courses</div>
            {startDate && endDate && (
              <div className="d-flex gap-3 mt-2">
                <div className="grid-sub-date">
                  <p>Start Date</p>
                  <p>{formattedDate(startDate)}</p>
                </div>
                <div className="grid-sub-date">
                  <p>End Date</p>
                  <p>{formattedDate(endDate)}</p>
                </div>
              </div>
            )}
          </>
        )}
        {!isTheory && (
          <>
            {taskProgressPercentage === 100 ? (
              <div className="complete-badge">
                <img src={greenCheckedFilled} alt="" />
                <span>Completed</span>
              </div>
            ) : (
              <CommonProgressBar
                width={taskProgressPercentage}
                label={taskProgressPercentage + "%"}
                hasPassed={passed}
              />
            )}
          </>
        )}
        {showDuration && (
          <span>Total Duration: {formatDuration(totalDuration)} </span>
        )}
      </div>
    </div>
  );
};
